import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPhotoFilm,
  faKey,
  faRunning,
  faBus,
  faHome,
  faCalendar,
  faIdCard,
  faClock,
  faXmark,
  faCalendarPlus,
  faSunBright,
  faArrowLeft,
  faTableCellsLarge,
  faTableCells,
  faGrid,
  faList,
  faLightbulbSlash,
  faPlayCircle,
  faHouseUser,
  faCheck,
  faChevronDown,
  faChevronUp,
  faSignOut,
  faSunrise,
  faSun,
  faMoonStars,
  faSunset,
  faBan,
  faAngleLeft,
  faAngleRight,
  faRefresh,
  faVolume,
  faImage,
  faMinusCircle,
  faCirclePlus,
  faAlignLeft,
  faSliders,
  faUserFriends,
  faSoup,
  faInfoCircle,
  faMessageLines,
  faDeleteLeft,
  faEdit,
  faArrowRight,
  faRepeat,
} from '@fortawesome/pro-regular-svg-icons';

// REGULAR

library.add(
  faSunset,
  faPhotoFilm,
  faKey,
  faRunning,
  faBus,
  faHome,
  faCalendar,
  faIdCard,
  faClock,
  faXmark,
  faCalendarPlus,
  faSunBright,
  faArrowLeft,
  faTableCellsLarge,
  faTableCells,
  faGrid,
  faList,
  faLightbulbSlash,
  faPlayCircle,
  faHouseUser,
  faCheck,
  faChevronDown,
  faChevronUp,
  faSignOut,
  faSunrise,
  faSun,
  faMoonStars,
  faBan,
  faAngleLeft,
  faAngleRight,
  faRefresh,
  faVolume,
  faImage,
  faMinusCircle,
  faCirclePlus,
  faAlignLeft,
  faSliders,
  faUserFriends,
  faSoup,
  faInfoCircle,
  faMessageLines,
  faDeleteLeft,
  faEdit,
  faArrowRight,
  faRepeat
);
